import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { GenerationModelDetails } from '~/domain/dicom/dicomBase';
import { formatModalityHint } from '~/utils/transforms/predictionModelsDataTransforms';

type ModelDetailsProps = {
    generationModel?: GenerationModelDetails;
    fullWidth?: boolean;
};

export default function ModelDetails({
    generationModel,
    fullWidth,
}: ModelDetailsProps) {
    if (!generationModel?.label) {
        return null;
    }

    const modelName = generationModel.label || generationModel.name;
    const modelLabel = generationModel.version
        ? `${modelName} v. ${generationModel.version}`
        : modelName;
    const modalityHint = formatModalityHint(generationModel);

    return (
        <Box
            display="flex"
            alignItems="center"
            gap={1}
            width={fullWidth ? '100%' : 'auto'}
            justifyContent={fullWidth ? 'space-between' : 'flex-start'}
        >
            <Typography fontSize={10} color="text.secondary" noWrap>
                {modalityHint
                    ? `AI Generated (${modalityHint})`
                    : 'AI Generated'}
            </Typography>
            <Typography
                fontSize={10}
                color="text.secondary"
                noWrap
                title={modelLabel}
                sx={{ minWidth: 0 }}
            >
                {modelLabel}
            </Typography>
        </Box>
    );
}
